import { Plan } from '../types';

export const PRO_PLAN: Plan = {
  id: 'displai-pro',
  productIdentifier: 'pro',
  name: 'Displai Pro',
  planTitle: 'A plan for brilliance!',
  planDescription: 'Everything you need to go live fast',
  features: [
    {
      id: 'player',
      type: 'device',
      name: 'A Displai Player',
    },
    {
      id: 'license',
      type: 'license',
      name: 'A Displai License',
    },
    {
      id: 'upload',
      type: 'feature',
      name: 'Upload, schedule & publish content from one dashboard',
    },
    {
      id: 'locations',
      type: 'feature',
      name: 'Unlimited locations',
    },
    {
      id: 'remote',
      type: 'feature',
      name: 'Manage and monitor screens remotely',
    },
    {
      id: 'playlists',
      type: 'feature',
      name: 'Smart playlists & scheduling tools',
    },
    {
      id: 'apps',
      type: 'feature',
      name: '50+ apps & POS integrations',
    },
    {
      id: 'onboarding',
      type: 'feature',
      name: 'Personalized onboarding',
    },
    {
      id: 'support',
      type: 'feature',
      name: '24/7 support',
    },
  ],
  monthly: {
    license: {
      currency: 'USD',
      price: 39.0,
      billingPeriod: 'monthly',
    },
    device: {
      currency: 'USD',
      price: 199.0,
      billingPeriod: null,
    },
  },
  annually: {
    license: {
      currency: 'USD',
      price: 420.0,
      billingPeriod: 'annually',
      badge: 'Save 12%',
    },
    device: {
      currency: 'USD',
      price: 99.0,
      billingPeriod: null,
      badge: 'Save 50%',
    },
  },
};

export const BLACK_FRIDAY_PRO_PLAN: Plan = {
  id: 'displai-pro-black-friday',
  productIdentifier: 'pro',
  name: 'Displai Pro',
  planTitle: 'A plan for brilliance!',
  planDescription: 'Everything you need to go live fast',
  features: [
    {
      id: 'player',
      type: 'device',
      name: 'A Displai Player',
    },
    {
      id: 'license',
      type: 'license',
      name: 'A Displai License',
    },
    {
      id: 'upload',
      type: 'feature',
      name: 'Upload, schedule & publish content from one dashboard',
    },
    {
      id: 'locations',
      type: 'feature',
      name: 'Unlimited locations',
    },
    {
      id: 'remote',
      type: 'feature',
      name: 'Manage and monitor screens remotely',
    },
    {
      id: 'playlists',
      type: 'feature',
      name: 'Smart playlists & scheduling tools',
    },
    {
      id: 'apps',
      type: 'feature',
      name: '50+ apps & POS integrations',
    },
    {
      id: 'onboarding',
      type: 'feature',
      name: 'Personalized onboarding',
    },
    {
      id: 'support',
      type: 'feature',
      name: '24/7 support',
    },
  ],
  monthly: {
    license: {
      currency: 'USD',
      price: 39.0,
      billingPeriod: 'monthly',
    },
    device: {
      currency: 'USD',
      price: 199.0,
      billingPeriod: null,
      promotionPrice: 99.0,
      showPromotionPrice: true,
      badge: 'Save 50%',
    },
  },
  annually: {
    license: {
      currency: 'USD',
      price: 468.0,
      billingPeriod: 'annually',
      badge: 'Free Device',
    },
    device: {
      currency: 'USD',
      price: 0,
      promotionPrice: 0.0,
      billingPeriod: null,
      badge: '$199 Value',
    },
  },
};

export const MIN_PLAN_COUNT = 1;

export const DEFAULT_PLAN_COUNT = 1;

export const MAX_POLL_COUNT = 5;
export const PROMOTION_PLAN_COUNT = 10;

export const BLACK_FRIDAY_PROMOTION_PLAN_COUNT = 2;
